import type {
	CandidateInterviewActionV1,
	CandidateInterviewAttemptV1,
	CandidateInterviewV1,
} from '@/shared/api';

export function safeInterviewRedirect(url?: string) {
	if (!url || /[\\\s\u0000-\u001f\u007f]/.test(url)) return null;
	if (url.startsWith('/')) return url.startsWith('//') ? null : url;
	try {
		const parsed = new URL(url);
		return ['http:', 'https:'].includes(parsed.protocol) &&
			!parsed.username &&
			!parsed.password
			? url
			: null;
	} catch {
		return null;
	}
}
export function completionPath(id: string, attemptId?: string) {
	const base = `/interviews/${encodeURIComponent(id)}/complete`;
	return attemptId ? `${base}?attempt=${encodeURIComponent(attemptId)}` : base;
}
export function hasInterviewCards(action?: CandidateInterviewActionV1) {
	return !action || action === 'standard' || action === 'ui_report';
}
export function reportVisible(
	action?: CandidateInterviewActionV1,
	redirectReport?: string,
	courseReward?: CandidateInterviewAttemptV1['courseReward'],
) {
	return (
		!!courseReward ||
		!action ||
		action === 'ui_report' ||
		(action === 'redirect' && redirectReport === 'ui')
	);
}

export function hasPromoCreditsOutcome(
	attempt?: Pick<
		CandidateInterviewAttemptV1,
		'action' | 'reason' | 'courseReward'
	>,
) {
	return (
		attempt?.action === 'free_interview_promo' &&
		attempt.reason === 'credits_exhausted' &&
		!attempt.courseReward
	);
}

/** Keep an in-progress attempt in the interface stored in its snapshot. */
export function usesReportOverview(interview: CandidateInterviewV1) {
	if (
		interview.attempt?.status === 'completed' &&
		interview.attempt.courseReward
	)
		return true;
	const action =
		interview.attempt?.status === 'in_progress'
			? (interview.attempt.action ?? interview.action)
			: interview.action;
	return action === 'ui_report';
}
